<!--
 * @Description: 
 * @Autor: yd
 * @Date: 2020-07-01 20:05:47
 * @最后编辑: Betway
 * @最后修改时间: 2023-06-08 10:46:19
--> 
<template>
  <div>
    <mrc_ess_iconGroup :is_disabled="$store.state.iconstatus" :showReturn="false"
      :showEdit="hasBtn('edit-staff-management')" :show_del="hasBtn('delete-staff-management')" @handleEdit="handleEdit"
      @handleDel="handleDel">

    </mrc_ess_iconGroup>
    <v-tabs v-model="tab" grow background-color="#eeeef0" @change="tabchange">
      <v-tab v-for="(item, index) in items" class="text-capitalize" :key="index">
        {{ item.tab }}
      </v-tab>
    </v-tabs>

    <v-tabs-items v-model="tab">
      <v-tab-item>
        <staffmaterial ref="staffmaterial" :iconstatus="readonly" @changeReadonly="handleEdit" @groupChange="()=>{
          $refs.staffGroup.getdetail()
          }" @detail="(data)=>{
          groupId=data.staff_property_master_uuid||null
          if($refs.staffGroup) $refs.staffGroup.staff_property_master_uuid=data.staff_property_master_uuid||null
          }"></staffmaterial>
      </v-tab-item>

      <v-tab-item>
        <staffGroup  :readonly="readonly" @changeReadonly="handleEdit" type="user" @changeGroup="(e)=>{
          $refs.staffmaterial.$refs.employeemsg.stafflist.staff_property_master_uuid=e
          $refs.staffmaterial.$refs.employeemsg.success(false)
          }" ref="staffGroup" :group-id="groupId">
        </staffGroup>
      </v-tab-item>
    </v-tabs-items>
  </div>
</template>

<script>
import { getStaffPropertyGroupDetail } from "@/service/api/staffPropertyGroup.js";
import { deleteStaff } from "@/service/api/staffmsg.js";
import staffmaterial from "../modules/staffmaterial.vue";
import staffGroup from "../modules/staffGroup.vue";
import propety from "../modules/propety";

export default {
  components: {
    staffmaterial,
    staffGroup,
  },
  props: {},
  data() {
    return {
      tab: 0,
      readonly: true, //默认只读
      list: {},
      groupId:null,
    };
  },
  beforeDestroy() {
    this.$store.commit("setTab", "");
  },
  created() {
  },
  async mounted() {
    this.readonly = this.$store.state.iconstatus;
    this.tab = this.$store.state.tab;
    this.$store.commit("setTab", this.tab);
  },
  methods: {
    tabchange() {
      this.$store.commit("setTab", this.tab);
    },
    handleEdit() {
      this.readonly = !this.readonly;
      this.$store.commit("set_iconstatus", this.readonly);
    },
    handleDel() {
      this.$myConfirm({
        content: this.$t("message_Confirm_the_deletion"),
      }).then((res) => {
        deleteStaff({ uuid: this.$store.state.uuid }).then((res) => {
          if (res.code == 200) {
            this.$Message({
              text: this.$t("message_The_deletion_was_successful"),
            });
            this.$router.push({
              name: "staffmanagement",
            });
          }
        });
      });
    },
  },
  computed: {
    items() {
      return [
        { tab: this.$t("label_Employee_profile") },
        { tab: this.$t("label_propety") },
      ];
    },
  },
  watch: {
    readonly: {
      handler(v) {
        if (!this.$store.state.uuid) return;
        if (!v) {
          this.$route.meta.title = "label_edit_employee_information";
          this.$store.commit(
            "set_page_title",
            "label_edit_employee_information"
          );
        } else {
          this.$route.meta.title = "label_view_employee_information";
          this.$store.commit(
            "set_page_title",
            "label_view_employee_information"
          );
        }
      },
      immediate: true,
    },
  },
};
</script>

<style scoped></style>
